import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import {
  NDT_ANCHOR_HOST,
  NDT_ANCHOR_INPUTS,
  NDT_BUTTON_HOST,
  NDT_BUTTON_INPUTS,
  NDtAnchorBase,
  NDtButtonBase,
} from './button-base';

@Component({
  selector: 'button[ndt-primary-button], button[ndt-secondary-button], button[ndt-tertiary-button]',
  template: '<ng-content></ng-content>',
  inputs: NDT_BUTTON_INPUTS,
  host: NDT_BUTTON_HOST,
  exportAs: 'ndtButton',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NDtButton extends NDtButtonBase {}

@Component({
  selector: 'a[ndt-anchor], a[ndt-primary-button], a[ndt-secondary-button], a[ndt-tertiary-button]',
  template: '<ng-content></ng-content>',
  exportAs: 'nDtButton, nDtAnchor',
  host: NDT_ANCHOR_HOST,
  inputs: NDT_ANCHOR_INPUTS,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NDtAnchor extends NDtAnchorBase {}
